import { createSelector } from 'reselect';
import { getAllDereferenced, getAllResources } from './all';

export var doesResourceExist = function doesResourceExist(selector, id) {
  return createSelector(getAllDereferenced, selector, function (allDereferenced, resource) {
    var idToCheck = resource ? resource.id || resource['@id'] || resource : id;
    return !!(idToCheck && allDereferenced && allDereferenced[idToCheck]);
  });
};

export var hasResourceBeenFetched = function hasResourceBeenFetched(selector, resourceType) {
  return createSelector(getAllResources, selector, function (allResources, resource) {
    return !!(resource && allResources && allResources[resourceType] && allResources[resourceType][resource.id || resource['@id'] || resource]);
  });
};

export var isResourceLoading = function isResourceLoading(selector, id) {
  return createSelector(getAllDereferenced, selector, function (allDereferenced, resource) {
    var idToCheck = resource ? resource.id || resource['@id'] || resource : id;
    return !!(idToCheck && allDereferenced && allDereferenced[idToCheck] && allDereferenced[idToCheck].loading === true);
  });
};